import '../common/EsTheme.css';
import './animate.css';

import WOW from 'wowjs';

window.wow = new WOW.WOW({
    live: false,
});

window.wow.init({
    offset: 50,
});

export function doNavInit() {
    'use strict';

    // ==== darkToggler -- MOVED, 2026-09-07.
    //
    // This used to hold the whole of the app's dark mode: a click listener on
    // #darkToggler that added or removed the `dark` class on <html>, run once at
    // mount so the page started dark. It is now EsThemeContext's, along with
    // light / dark / system and the two colour palettes, all set from the
    // palette menu (EsThemeMenu).
    //
    // The block is not left here as well. Two things toggling one class is the
    // shape where a control works until something else also has an opinion --
    // this listener would have fought `system` on every click, and won, silently.
    // There is one way to go dark and this is no longer it.

    // ======= Sticky
    //
    // Both lookups are null-checked, which they were not. This runs on EVERY
    // scroll event, so a page rendered without the footer -- or one where an
    // error boundary has replaced it -- threw once per frame of a scroll and
    // filled the console with an exception that said nothing about what was
    // wrong. The header and the button are chrome: their absence is a page
    // without them, not a fault.
    window.onscroll = function () {
        const ud_header = document.querySelector('.navBar');

        if (ud_header) {
            // WHERE THE BAR STICKS, and the ribbon moved it.
            //
            // offsetTop alone means "stick once the bar has reached the top of
            // the viewport", which is right when the bar starts at the top.
            // With an announcement up it does not: .esRibbonOffset puts the bar
            // at top: --es-ribbon-room, so offsetTop is 41px and nothing sticks
            // until 41 pixels have been scrolled -- during which the bar is
            // still absolute, slides up with the page, and passes UNDER the
            // fixed ribbon before snapping back down. That is the logo
            // disappearing briefly on the first flick of a scroll.
            //
            // The bar should stick when it reaches the ribbon, not when it
            // reaches the top of the screen, so the room the ribbon took comes
            // back off. Read from the element that reserves it rather than from
            // the custom property, because that element is the one thing that
            // knows whether there IS a ribbon: no announcement, no class, no
            // padding, and the threshold is offsetTop exactly as before.
            const ud_offset = document.querySelector('.esRibbonOffset');
            const ribbonRoom = ud_offset
                ? parseFloat(getComputedStyle(ud_offset).paddingTop) || 0
                : 0;

            const sticky = ud_header.offsetTop - ribbonRoom;

            if (window.scrollY > sticky) {
                ud_header.classList.add('stickyNav');
            } else {
                ud_header.classList.remove('stickyNav');
            }
        }

        // show or hide the back-top-top button
        const backToTop = document.querySelector('.back-to-top');
        if (backToTop) {
            if (document.body.scrollTop > 50 || document.documentElement.scrollTop > 50) {
                backToTop.style.display = 'flex';
            } else {
                backToTop.style.display = 'none';
            }
        }
    };

    // ==== navbarToggler -- MOVED, 2026-09-15.
    //
    // This used to hold the mobile menu: a click listener on #navbarToggler that
    // toggled `hidden` on #navbarCollapse, plus a listener on every <a> the panel
    // contained AT MOUNT to close it again. It is now EsNavBar's own `menuOpen`
    // state, rendered into both elements' className, for the reason the
    // darkToggler note above gives -- two things toggling one class is the shape
    // where a control works until something else also has an opinion. React owns
    // that className, so there is one way to open the menu and this is no longer
    // it. EsNavBar carries the full argument, including why a snapshot of the
    // links could not stay correct across a login.
    //
    // Nothing is left here as a fallback on purpose. A fallback would be the
    // second opinion.

    function scrollTo(element, to = 0, duration = 500) {
        const start = element.scrollTop;
        const change = to - start;
        const increment = 20;
        let currentTime = 0;

        const animateScroll = () => {
            currentTime += increment;

            const val = Math.easeInOutQuad(currentTime, start, change, duration);

            element.scrollTop = val;

            if (currentTime < duration) {
                setTimeout(animateScroll, increment);
            }
        };

        animateScroll();
    }

    Math.easeInOutQuad = function (t, b, c, d) {
        t /= d / 2;
        if (t < 1) return (c / 2) * t * t + b;
        t--;
        return (-c / 2) * (t * (t - 2) - 1) + b;
    };

    // Last in this function, and null-checked for that reason as much as any
    // other: an unguarded lookup here threw before it returned, and every line
    // above it that had already run stayed run while everything after it -- of
    // which there is now nothing -- did not. A function that wires a page should
    // not be able to half-wire it.
    const backToTop = document.querySelector('.back-to-top');

    if (backToTop) {
        backToTop.onclick = () => {
            scrollTo(document.documentElement);
        };
    }
}
